import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/groups/{slug}/students/` redirects to the first subnav, All Students, as
 * legacy does; without it the tab bar renders over an empty outlet.
 *
 * Done in `beforeLoad`, since no data is needed, so the empty tab body never
 * paints. Unlike legacy, only the bare slug redirects, not an unknown slug
 * under the tab.
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/groups/$groupName/students/all-students/',
      params: { groupName: params.groupName },
      replace: true,
    });
  },
});
